import { gql } from "@apollo/client";

export const updateTier = gql`
  mutation UpdateTier($id: ID!, $input: TierInput!) {
    updateTier(id: $id, input: $input) {
      id
      name
      programId
      entryThresholdMinor
      multiplier
      benefits
      requirements
      tierRevision
      createdAt
      updatedAt
      createdBy
      updatedBy
      deletedAt
      deletedBy
    }
  }
`;
